import { AnswerSummary } from 'cccisd-laravel-appdefs/dist/reportTemplates';
import WeightReport from './WeightReport';

export default [AnswerSummary, WeightReport];
